import React, { useEffect, useState } from 'react';
import "./PRDetail.scss";
import downArrow from "../../assets/icons-icon-arrow-down@2x.png";
import motif from "../../assets/motiff.png"
import dictionary from "i18next";

const PRDetail = (props) => {
  const [viewMore, setViewMore] = useState(false)
  useEffect(() => {
    window.scroll(0, 0)
  }, [])
  return (
    <>
      <div className="article-page-wrapper">

        <div className={`corporate-details-wrapper ${!viewMore && "with-view-more"}`}>
          <div dangerouslySetInnerHTML={{ __html: props.fields.Description && props.fields.Description.value }}>

          </div>
          {!viewMore && <div className="front"></div>}
        </div>
        {!viewMore && <div className="view-more" onClick={() => setViewMore(true)}><a >{dictionary.t("PressReleases-ViewMore", "VIEW MORE")}<img alt="down" src={downArrow} /></a></div>}
      </div>

    </>
  )
};

export default PRDetail;







